export { default } from './DesignShare';
